export default __webpack_public_path__ + "static/media/illus-escalier.232f72d5.svg";